import ModelBody from "./ExpcModel_Body.js";

export default {
  setDetailsByCategoryOptions(userData, categoryOptions) {
    userData.CategoryID = ModelBody.getCategoryDefault(categoryOptions);
  }
}